import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_left",
  "use": "arrow_left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow_left\"><path d=\"M7.3 17.7c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L5.4 13H21c.6 0 1-.4 1-1s-.4-1-1-1H5.4l3.3-3.3c.4-.4.4-1 0-1.4-.2-.2-.5-.3-.7-.3-.2 0-.5.1-.7.3L1.6 12l5.7 5.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol